import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-usermanager',
  template: require('./usermanager.component.html'),
  styles: [],
})
export class UserManagerComponent implements OnInit {
  expDetails: any;
  private columnDefs;
  private rowData;
  private rowHeight;
  api: any;
  columnApi: any;
  defaultColDefine;
  private gridColumnApi;
  private detailCellRendererParams;
  currentMonth: any;

  staffTypes: any;
  staff: any;
  designation: any;
  currentDate: any;



  constructor(

  ) {
    this.columnDefs = [
      { headerName: 'S.No.', field: 'sno', width: 80 },
      {
        headerName: 'User Role', field: '', width: 110, cellRenderer: function (params) {
          var eDiv = document.createElement('div');
          eDiv.innerHTML = `
          <a href=""><i class="icon-settings"></i></a>
        `;
          return eDiv;
        }
      },
      { headerName: 'Company', field: "comp" },
      { headerName: 'Name', field: "name" },
      { headerName: 'Division', field: "division" },
      { headerName: 'Head Qtr', field: "head_qtr" },
      { headerName: 'Designation', field: "desig" },
      { headerName: 'State', field: "state" },
      { headerName: 'Username', field: "username" },
      { headerName: 'Password', field: "password" },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowData = [
      { sno: '1', comp: "Entero Healthcare Solutions",name: "Ashutosh Sharma", division: "Surgical group", head_qtr: "Agartala",desig: "SO", state: "Tripura", username: "1218narayan", password: 11798 }
    ];
    this.rowHeight = 50;
  }
  ngOnInit() {
  }

  onGridReady = (params) => {
    this.api = params.api;
    // this.api.sizeColumnsToFit();
  }
}
